import { STAGING_URL, PROD_URL } from './constants';
import { capturePostHogEvent } from './posthog';

const isPendoAvailable = () => {
  return (
    window.pendo &&
    (window.location.hostname === STAGING_URL || window.location.hostname === PROD_URL)
  );
};

const track = (eventName, eventData = {}) => {
  if (!isPendoAvailable()) {
    return;
  }

  try {
    window.pendo.track(eventName, eventData);
  } catch (error) {
    console.error(`[Pendo Track Error] ${eventName}:`, error);
  }
};

export const trackJobStatusChanged = ({ job_id, job_title, old_status, new_status }) => {
  track('job_status_changed', {
    job_id,
    job_title,
    old_status: old_status || null,
    new_status,
  });
};

export const trackApplicantViewed = ({ candidate_id, application_id, job_id }) => {
  track('applicant_viewed', {
    candidate_id,
    application_id: application_id || null,
    job_id: job_id || null,
  });
  capturePostHogEvent('applicant_viewed', {
    candidate_id: candidate_id || null,
    application_id: application_id || null,
    job_id: job_id || null,
  });
};

export const trackApplicantStatusChanged = ({
  application_id,
  old_status,
  new_status,
  job_id,
  candidate_id,
}) => {
  track('applicant_status_changed', {
    application_id,
    old_status,
    new_status,
    job_id: job_id || null,
  });
  capturePostHogEvent('application_updated', {
    old_status: old_status || null,
    new_status: new_status || null,
    application_id,
    job_id: job_id || null,
    candidate_id: candidate_id || null,
  });
};

export const trackUserInvited = ({ email, user_type, school_id }) => {
  track('user_invited', {
    email,
    user_type,
    school_id: school_id || null,
  });
};

export const trackPrincipalStageChanged = ({ application_id, old_stage, new_stage }) => {
  track('principal_stage_changed', {
    application_id,
    old_stage: old_stage || null,
    new_stage,
  });
  capturePostHogEvent('application_updated', {
    old_status: old_stage || null,
    new_status: new_stage,
    application_id,
  });
};

export const trackHiringRequestSubmitted = () => {
  track('hiring_request_submitted');
};

export const trackHiringRequestActioned = ({ hiring_request_id, action, actioned_by }) => {
  track('hiring_request_actioned', {
    hiring_request_id,
    action,
    actioned_by,
  });
};

export const trackPrincipalCandidateContactClicked = ({
  application_id,
  candidate_id,
  candidate_email,
  job_id,
}) => {
  track('principal_candidate_contact_clicked', {
    application_id: application_id || null,
    candidate_id,
    candidate_email,
    job_id: job_id || null,
  });
};

export const trackPrincipalCandidateEmailSent = ({
  application_id,
  candidate_id,
  candidate_email,
  job_id,
  feature,
}) => {
  track('principal_candidate_email_sent', {
    application_id: application_id || null,
    candidate_id,
    candidate_email,
    job_id: job_id || null,
  });
  capturePostHogEvent('email_sent', {
    feature,
    application_id: application_id || null,
    candidate_id: candidate_id || null,
    job_id: job_id || null,
  });
};

export const trackAdminCandidateEmailSent = ({ application_id, candidate_id, job_id, feature }) => {
  track('admin_candidate_email_sent', {
    application_id: application_id || null,
    candidate_id,
    job_id: job_id || null,
  });
  capturePostHogEvent('email_sent', {
    feature,
    application_id: application_id || null,
    candidate_id: candidate_id || null,
    job_id: job_id || null,
  });
};

export const trackSchoolAdminCandidateEmailSent = ({
  application_id,
  candidate_id,
  job_id,
  feature,
}) => {
  track('school_admin_candidate_email_sent', {
    application_id: application_id || null,
    candidate_id,
    job_id: job_id || null,
  });
  capturePostHogEvent('email_sent', {
    feature,
    application_id: application_id || null,
    candidate_id: candidate_id || null,
    job_id: job_id || null,
  });
};
